module.exports = __webpack_public_path__ + "img/noteCat.79e2676d.png";